<template>
<div class="pa-body">

    <div class="f18 mb20">General</div>
    <div class="section mb20" v-if="settings">
        <label class="mb15">
            <input type="checkbox" v-model="settings.is_active">
            <div>
                <div>Activado</div>
                <div class="secondary-text">Determina si el totem está habilitado.</div>
            </div>
            <div class="checkmark"></div>
        </label>   

        <input-field class="mb15"
        v-model="settings.url"
        label="Dominio"
        placeholder="dominio.cl (sin www, sin http://)">
            <div class="append" slot="after" v-if="Auth.role=='admin' || Auth.role == 'sub_admin'">
                <domain-options :domain="settings.url"></domain-options>
            </div>
        </input-field>

        <input-field
        v-model="settings.access_code"
        type="password"
        label="Código"
        description="Código que se utiliza para acceder a la página y ajustes">
        </input-field>

    </div>


    <div class="f18 mb20">Personalización</div>
    <div v-if="settings" class="section mb20">

        <div class="hdvm mini">

            <div class="hs">

            <input-image
            label="Banner"
            v-model="settings.banner"
            path="banners/">
            </input-image>

            <input-image
            label="Splash"
            v-model="settings.splash_screen"
            path="banners/">
            </input-image>

            </div>
            
            <multiple-images-selector v-model="settings.carousel" label="Carrusel" imagePath="banners/">
            </multiple-images-selector>
        </div>

        <input-select class="mt15 mb15"
        label="Precio del menú"
        description="Determina como se mostrará el precio de los productos en la página"
        :items="optionsItemPrice"
        v-model="settings.item_price_display">
        </input-select>

        <input-select class="mb20"
        label="Visualización del menú"
        description="Determina como se mostrará el menú en la página"
        :items="[
            {text: 'Todos los productos', value: 'ALL', description: 'Se muestran todos los productos a la vez, para desplazarse entre secciones se hace scroll'},
            {text: 'Expandir secciones', value: 'EXPAND', description: 'Se muestran las secciones que se pueden expandir para mostrar los productos'},
            {text: 'Separar secciones', value: 'TABS', description: 'Sólo se muestran los productos de la sección seleccionada'}
        ]"
        v-model="settings.menu_display">
        </input-select>

        <input-select class="mb20"
        label="Número del Pedido"
        description="Determina la cantidad de dígitos que se mostrará al cliente como su número de pedido"
        :items="[
            {text: 'Número completo', value: 100},
            {text: 'Últimos 3 números', value: 3},
            {text: 'Últimos 2 números', value: 2},
        ]"
        v-model="settings.ticket_number_quantity">
        </input-select>

        <div class="flex mt20">
            <div class="flex-fill">
                <div class="bold">Personalizar Apariencia</div>
                <div class="secondary-text">Cambia los colores, tipografía y formas de la página web</div>
            </div>
            <button class="secondary" @click="$refs.customizationForm.Open(Util.Copy(settings), 'STYLE', 'TOTEM', settings.url)">Editar</button>
        </div>

        <div class="flex mt20">
            <div class="flex-fill">
                <div class="bold">Personalizar Estado del Pedido</div>
                <div class="secondary-text">Cambia los mensajes e imágenes del estado del pedido que se muestran al cliente</div>
            </div>
            <button class="secondary" @click="modalMessagesCustomization = Util.Copy(settings)">Editar</button>
        </div>

    </div>

    <div class="f18 mb20">Ajustes</div>

    <div class="section mb20" v-if="settings">

        <label class="mb10">
            <input type="checkbox" v-model="settings.accepts_takeaway"> Acepta pedidos para retirar <div class="checkmark"></div>
        </label>
        <label>
            <input type="checkbox" v-model="settings.accepts_serve"> Acepta pedidos para servir <div class="checkmark"></div>
        </label>

        <div class="separator mt15 mb15"></div>

        <div class="bold">Métodos de pago</div>
        <div class="secondary-text mb10">Configura si el tótem permite pagar con tarjeta, en caja o ambos.</div>

        <label class="mb10">
            <input type="checkbox" v-model="settings.accepts_card"> Pago con tarjeta <div class="checkmark"></div>
        </label>
        <label>
            <input type="checkbox" v-model="settings.accepts_counter"> Pago en caja <div class="checkmark"></div>
        </label>

        <div class="separator mt15 mb15"></div>

        <label class="mb10">
            <input type="checkbox" v-model="settings.tips_enabled"> <div class="flex column">
                <div class="bold">Propinas</div>
                <div class="secondary-text">Permite el ingreso de propinas desde el tótem</div>
            </div> <div class="checkmark"></div>
        </label>

        <input-field v-show="settings.tips_enabled" class="mt10"
        v-model="settings.tips_default"
        label="Propina por defecto"
        description="Propina por defecto al iniciar un pedido en el tótem. El cliente puede cambiarla o quitarla."
        type="float+"
        suffix="%">
        </input-field>

        <div class="separator mt15 mb15"></div>

        <div class="flex column">
            <div class="flex align-center">
                <label>
                    <input type="checkbox" v-model="settings.recommend_products_active">
                    <div class="checkmark"></div>
                </label>
                <div class="flex-fill">
                    <div class="bold">Recomendar Productos</div>
                </div>
                <button v-if="settings.recommend_products_active" class="secondary" @click="OpenModalItemsSelection()" v-tooltip="'Elige los productos que se mostrarán en los productos recomendados'">Seleccionar</button>
            </div>

            <div class="secondary-text mt5">Antes de enviar el pedido se mostrarán
                <span v-if="!settings.products_recommend.length || !settings.recommend_products_active">items relevantes o más vendidos para agregar</span>
                <span v-else class="bold"><span v-for="(prod, index) in settings.products_recommend" :key="prod.id"> {{ prod.title }}<span v-if="index < settings.products_recommend.length - 1">,</span></span></span>
            </div>

            <input-field
            v-if="settings.recommend_products_active && (settings.products_recommend.length == 0)"
            class="mt10"
            v-model="settings.recommend_items"
            type="int+"
            prefix="mostrar "
            suffix=" productos">
            </input-field>
        </div>

    </div>

    <div class="f18 mb20">Analíticas</div>
    <div class="section" v-if="settings">
        
        <input-field class="mb15"
        v-model="settings.google_analytics"
        label="Google Analytics ID"
        placeholder="G-XXXXXXXXXXX (Opcional)">
        </input-field>
        
        <input-field class="mb15"
        v-model="settings.facebook_pixel"
        label="Facebook Pixel ID"
        placeholder="123456789012345 (Opcional)">
        </input-field>

        <input-field
        v-model="settings.facebook_pixel_access_token"
        label="Facebook Pixel Token de Acceso"
        placeholder="Token de Acceso (Opcional)">
        </input-field>
    </div>

    <customization-form
    ref="customizationForm"
    initialZoom="tablet"
    @OnSaved="SaveCustomization($event)">
    </customization-form>

    <modal v-model="modalMessagesCustomization" dir="right" :modalClass="['fill', 'md right h100']" title="Estado del Pedido">
        <div class="pa20" v-if="modalMessagesCustomization">
            <input-field :lines="3"
            label="Mensaje de Bienvenida"
            description="Determina el mensaje que se mostrará en la pantalla inicial"
            v-model="modalMessagesCustomization.welcome_message">
            </input-field>

            <div class="flex column mt15">
                <div class="bold mb10">Pantalla de Pago</div>
                <div class="flex">
                    <input-image v-model="modalMessagesCustomization.image_order_payment" :crop="true" :cropSize="[500, 410]" :cropViewport="[250, 205]" path="banners/"></input-image>
                    <input-field class="ml20 fill" v-model="modalMessagesCustomization.status_order_payment" :lines="3" placeholder="(Opcional)"></input-field>
                </div>
            </div>

            <div class="flex column mt15">
                <div class="bold mb10">Pantalla de Error</div>
                <div class="flex">
                    <input-image v-model="modalMessagesCustomization.image_order_error" :crop="true" :cropSize="[500, 410]" :cropViewport="[250, 205]" path="banners/"></input-image>
                    <input-field class="ml20 fill" v-model="modalMessagesCustomization.status_order_error" :lines="3" placeholder="(Opcional)"></input-field>
                </div>
            </div>

            <div class="flex column mt15">
                <div class="bold mb10">Pantalla de Éxito</div>
                <div class="flex">
                    <input-image v-model="modalMessagesCustomization.image_order_success" :crop="true" :cropSize="[500, 410]" :cropViewport="[250, 205]" path="banners/"></input-image>
                    <input-field class="ml20 fill" v-model="modalMessagesCustomization.status_order_success" :lines="3" placeholder="(Opcional)"></input-field>
                </div>
            </div>

        </div>
        <button class="primary purple" slot="actions" @click="settings = modalMessagesCustomization; modalMessagesCustomization = null">Aceptar</button>
    </modal>

    <modal v-model="modalStore" dir="right" :modalClass="['fill', 'md right h100']" title="Productos recomendados">
        <input-select class="ml5"
        v-if="modalStore"
        ref="CurrentItem"
        inputClass="icon primary"
        :triggerFirstValueChanged="false"
        @OnValueChanged="AddToItemsSelection($event)"
        :items="storeMenuItems"
        :canType="'search'"
        icon="plus"
        slot="options"
        callbackOnly>
        </input-select>
        <div v-if="modalStore" class="pa20">
            <div v-if="!modalStore.array.length" class="secondary-text ta-center">No hay items seleccionados</div>
            <draggable
            :list="dragList"
            handle=".handle"
            :animation="200"
            group="items">
                <div class="flex well mb10" v-for="(item, index) in dragList" :key="index">
                    <div class="flex-fill">
                        <div class="flex align-center">
                            <i class="icon icon-drag-handle handle"></i>
                            <div class="align-center">{{ item.title }} </div>
                            <div class="flex-fill"></div>
                            <i class="options icon-trash ml10 c4 align-center" @click.stop="modalStore.array.splice(index, 1)"></i>
                        </div>
                    </div>
                </div>
            </draggable>
        </div>
        <button slot="actions" class="primary purple" @click="SaveItemsSelection()">Aceptar</button>
    </modal>
    
</div>
</template>

<script>
import MultipleImagesSelector from '../common/MultipleImagesSelector.vue';
import CustomizationForm from '../common/CustomizationForm.vue';
import DomainOptions from '../common/DomainOptions.vue';

export default {
    components: { CustomizationForm, DomainOptions, MultipleImagesSelector},
    data() {
        return {
            settings: null,
            optionsItemPrice: [
                {value: 'ITEM_PRICE', text: 'Producto', description: 'Precio del producto'},
                {value: 'MODIFIER_PRICE', text: 'Modificador', description: 'Precio del primer modificador, si no hay se mostrará el precio del producto'},
                {value: 'AUTO', text: 'Auto', description: 'Precio del producto, si no hay se mostrará el precio de un modificador, si no hay se oculta'},
                {value: 'HIDDEN_ZERO', text: 'Productos con precio', description: 'Precio del producto pero no se mostrará si el precio es cero'},
                {value: 'HIDDEN_ALL', text: 'Oculto', description: 'No mostrará el precio'},
            ],
            modalMessagesCustomization: null,
            modalStore: null,
            storeMenuItems: [],
            dragList: [],
        }
    },
    mounted() {        
        
    },
    methods: {    
        Init(force)
        {
            if(force || !this.settings)
            {
                this.Loading();
                axios.get(`/settings/totem/${this.Local.id}`).then(res => {
                    this.Response(res);
                    this.settings = res.data;
                    if(!this.settings.products_recommend) this.settings.products_recommend = [];
                    if(this.settings.recommend_items == null) this.settings.recommend_items = 5;
                }).catch(err => {
                    this.Response(err);
                });
            }
        },
        Save() {
            
            if(this.settings.url)
            {
                if(!this.Util.IsValidInfluyeDomain(this.settings.url))
                    return this.Info('Dominio inválido');
            }

            if(this.is_active && (!this.access_code || this.access_code.length < 6))
                return this.Info('Código de acceso inválido');

            if(this.is_active && (!this.accepts_takeaway && !this.accepts_serve))
                return this.Info('Se debe activar retiro o servir');

            if(this.settings.is_active && (!this.settings.accepts_card && !this.settings.accepts_counter))
                return this.Info('Se debe activar pago con tarjeta o pago en caja');

            if(this.settings.recommend_products_active && this.settings.recommend_items <= 0 && this.settings.products_recommend.length == 0)
                return this.Info('Debe ingresar cantidad mayor a 0 en productos a recomendar.');

            this.Loading();
            axios.post(`/settings/totem/${this.Local.id}`, this.settings).then(res => {
                this.Info('Configuración guardada.');
            }).catch(err => {
                this.Response(err);
            });

        },
        SaveCustomization(data) {
            this.settings = data;
            this.Save();
            this.$refs.customizationForm.Close();
        },
        async OpenModalItemsSelection() {
            this.modalStore = { array: [...this.settings.products_recommend] };
            this.dragList = this.modalStore.array;

            try {
                const res = await axios.get(`/menu/${this.Local.id}/complete`);
                let itemSelect = [];
                let aux = [];
                res.data.forEach(element => {
                    if(!element.invisible) aux.push(...element['items']);
                });
                aux.forEach(item => {
                    if(!item.invisible){
                        itemSelect.push({
                            text: `${item.title}`,
                            value: { dataitem: item },
                        });
                    }
                });
                this.storeMenuItems = itemSelect;
                this.Response(res);
            } catch (err) {
                this.Response(err);
            }
        },
        AddToItemsSelection(data) {
            const itemExists = this.modalStore.array.find(item => item.id === data.dataitem.id);
            if(itemExists) return this.Info('El ítem ya se encuentra agregado en la lista.');
            this.modalStore.array.push({id: data.dataitem.id, title: data.dataitem.title});
        },
        SaveItemsSelection() {
            this.settings.products_recommend = this.modalStore.array;
            this.modalStore = null;
        },
    },
}
</script>